import {mapMutations, mapGetters} from 'vuex';
import {
    SHOW_POPUP_AVAILABILITY_PROPS,
    SET_CURRENT_REQUISITE,
    SHOW_POPUP_BASKET,
    CHANGE_POPUP_ADD_TO_FAVORITES
} from "@/store/mutation-types";

export default {
    name: 'product',
    props: ['product'],
    computed: {
        ...mapGetters({
            viewType: 'category/viewType',
        }),
        viewProductType(){
            if(this.$route.name === 'categories'){
                if(this.viewType === 'tile'){
                    return true;
                }else{
                    return false
                }
            }else{
                return true;
            }
        }
    },
    methods: {
        ...mapMutations({
            changePopupCheck: `requisite/${SHOW_POPUP_AVAILABILITY_PROPS}`,
            setRequisite: `requisite/${SET_CURRENT_REQUISITE}`,
            changePopupBasket: `requisite/${SHOW_POPUP_BASKET}`,
            changeShowPopupAddFavorites: `favorites/${CHANGE_POPUP_ADD_TO_FAVORITES}`,
        }),
        setItemAndOpenPopupCheck(status, item){
            this.changePopupCheck(status);
            this.setRequisite(item);
        },
        setItemAndOpenPopupBasket(status, item){
            this.changePopupBasket(status);
            this.setRequisite(item);
        },
        setItemAndOpenPopupFavorites(status, item){
            this.changeShowPopupAddFavorites(status);
            this.setRequisite(item);
        },
    },
}
